export enum GuidedBreathingModeEnum {
        'disabled',
        'paul',
        'laura',
        'bell'
}

export const GuidedBreathingModeArray = [
  'paul',
  'laura',
  'bell',
  'disabled'];

export enum BreathingTimeEnum {
        'BreatheIn',
        'BreatheOut',
        'Hold'}

export type BreathingTime = BreathingTimeEnum.BreatheIn | BreathingTimeEnum.BreatheOut | BreathingTimeEnum.Hold;

export type GuidedBreathingMode = GuidedBreathingModeEnum.disabled | GuidedBreathingModeEnum.paul |
 GuidedBreathingModeEnum.laura | GuidedBreathingModeEnum.bell;